const historySections = document.querySelectorAll( "section.history-slider" );
historySections.forEach( ( section ) => {
  let current = 0;

  const sliderGroup = section.querySelector( ".slider-container" ),
    slider = section.querySelector( ".slider" ),
    slides = section.querySelectorAll( ".slider-container svg .slide" ),
    prev = section.querySelector( ".slider-controls .prev" ),
    next = section.querySelector( ".slider-controls .next" ),
    navCircles = section.querySelectorAll( ".history-nav li" );
  let amount = 300;
  console.log( "amount", amount );

  //     console.log(sliderGroup.offsetLeft)
  //   let maxSlides = Math.floor((window.innerWidth - (sliderGroup.offsetLeft + 150)) / amount); // then check amount vs slides.length etc...
  //   // enable/disable buttons
  //   function handleButtonEnabling() {
  //     prev.disabled = current === 0;
  //     next.disabled =
  //       current >= slides.length - maxSlides || maxSlides >= slides.length;
  //   }
  //   handleButtonEnabling(); // at the start if we are on a huge screen

  function activateNav () {
    navCircles.forEach( ( circle, index ) => {
      if ( index === current ) {
        circle.classList.add( "active" );
      } else {
        circle.classList.remove( "active" );
      }
    } );
  }

  navCircles.forEach( ( circle, index ) => {
    circle.addEventListener( "click", function () {
      if ( index === current ) {
        return;
      }
      console.log( "nav clicked" );
      current = index;
      sliderGroup.style.transform = `translateX(${ current * amount * -1 }px)`;
      // handleButtonEnabling();
      sliderGroup.classList.add( "sliding" );
      activateNav();
      setTimeout( () => {
        sliderGroup.classList.remove( "sliding" );
      }, 500 );
    } );
  } );

  // previous
  prev.addEventListener( "click", function () {
    console.log( "prev clicked" );
    if ( current == 0 ) return;

    current--;
    sliderGroup.style.transform = `translateX(${ current * amount * -1 }px)`;
    // handleButtonEnabling();
    sliderGroup.classList.add( "sliding" );
    activateNav();
    setTimeout( () => {
      sliderGroup.classList.remove( "sliding" );
    }, 500 );
  } );

  // next
  next.addEventListener( "click", function () {
    console.log( "next clicked", current, window.innerWidth );

    if ( window.innerWidth >= 1024 && current == slides.length - 3 ) return;
    if ( window.innerWidth < 1024 && current == slides.length - 1 ) return;
    current++;
    sliderGroup.style.transform = `translateX(${ current * amount * -1 }px)`;
    // handleButtonEnabling();
    sliderGroup.classList.add( "sliding" );
    activateNav();
    setTimeout( () => {
      sliderGroup.classList.remove( "sliding" );
    }, 500 );
  } );

  window.addEventListener( "resize", function () {
    current = 0;
    maxSlides = Math.floor(
      ( window.innerWidth - ( sliderGroup.offsetLeft + 150 ) ) / amount
    );
    sliderGroup.style.transform = `translateX(0px)`;
    // handleButtonEnabling();
  } );
} );
